module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', {
    staticClass: "bodyPadding productsalesScreen",
    attrs: {
      "id": "inspire"
    }
  }, [_c('mo-header'), _vm._v(" "), _c('v-content', [_c('ps-head'), _vm._v(" "), _c('ps-list')], 1)], 1)
},staticRenderFns: []}